export default __webpack_public_path__ + "static/media/yazeed photo.c92c6f3e.png";